import './OIDCProviders.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { OidcProviderLoginButton } from './OidcProviderLoginButton';
import React from 'react';
import { securityActions } from '@sonar-software/sonar-security';
import { useAsyncStateWithPreload } from '@hooks';
const selectors = createAsyncSelectors((state) => state.security.oidcConfigurations.bySubdomain.get);
export const OidcProviders = () => {
    const { data } = useAsyncStateWithPreload(selectors, securityActions.requestGetSecurityOidcConfigurationsBySubdomain, true);
    if (!(data === null || data === void 0 ? void 0 : data.length)) {
        return null;
    }
    return (React.createElement("div", { id: 'oidc-providers' },
        React.createElement("div", { className: 'subtext' }, COPY_SPECIFIC.OR_LOGIN_USING),
        React.createElement("div", { className: 'providers' }, data.map((config) => React.createElement(OidcProviderLoginButton, { config: config, key: config.oidcClientID })))));
};
